// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Index_bottomLine__2aeG8","dots":"Index_dots__1zFg2","dot":"Index_dot__2oBl7","active":"Index_active__2YvD9"};